import { render, staticRenderFns } from "./NavbarApp.vue?vue&type=template&id=22b280fc&scoped=true"
import script from "./NavbarApp.vue?vue&type=script&lang=js"
export * from "./NavbarApp.vue?vue&type=script&lang=js"
import style0 from "./NavbarApp.vue?vue&type=style&index=0&id=22b280fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b280fc",
  null
  
)

export default component.exports